import React from 'react';

export const GoogleCalendarSearchResultIcon = (): React.JSX.Element => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="32" height="32" rx="8" fill="white" />
			<rect
				x="0.508324"
				y="0.508324"
				width="30.9834"
				height="30.9834"
				rx="7.49168"
				stroke="#0B1228"
				strokeOpacity="0.14"
				strokeWidth="1.01665"
			/>
			<g>
				<path
					d="M21.0942 10.8996L16.5094 10.3902L10.9057 10.8996L10.3962 15.9939L10.9056 21.0881L15.9999 21.7249L21.0942 21.0881L21.6036 15.8666L21.0942 10.8996Z"
					fill="white"
				/>
				<path
					d="M12.9956 18.8033C12.6149 18.546 12.3512 18.1704 12.2073 17.6737L13.0912 17.3094C13.1714 17.6151 13.3115 17.8519 13.5114 18.0201C13.7101 18.1882 13.9521 18.271 14.2348 18.271C14.5239 18.271 14.7723 18.1831 14.9798 18.0073C15.1873 17.8315 15.2919 17.6074 15.2919 17.3362C15.2919 17.0586 15.1823 16.8318 14.9633 16.6561C14.7442 16.4804 14.4692 16.3925 14.1406 16.3925H13.6299V15.5176H14.0883C14.371 15.5176 14.6092 15.4412 14.8028 15.2884C14.9964 15.1355 15.0932 14.9267 15.0932 14.6605C15.0932 14.4236 15.0065 14.2351 14.8334 14.0938C14.6602 13.9525 14.4411 13.8811 14.1749 13.8811C13.9151 13.8811 13.7088 13.95 13.5559 14.0887C13.4031 14.2275 13.2923 14.3982 13.2223 14.5994L12.3474 14.2352C12.4633 13.9066 12.676 13.6162 12.988 13.3653C13.3 13.1145 13.6986 12.9883 14.1826 12.9883C14.5404 12.9883 14.8626 13.0572 15.148 13.196C15.4332 13.3348 15.6574 13.5271 15.8191 13.7716C15.9808 14.0173 16.0611 14.2925 16.0611 14.5981C16.0611 14.9101 15.986 15.1737 15.8356 15.3902C15.6853 15.6067 15.5007 15.7722 15.2816 15.8882V15.9403C15.5707 16.0613 15.8063 16.246 15.9923 16.4944C16.1769 16.7427 16.2698 17.0395 16.2698 17.3859C16.2698 17.7323 16.182 18.0418 16.0062 18.3131C15.8304 18.5844 15.5872 18.7983 15.279 18.9536C14.9696 19.109 14.6219 19.1879 14.236 19.1879C13.789 19.1892 13.3764 19.0606 12.9956 18.8033Z"
					fill="#1A73E8"
				/>
				<path
					d="M18.4191 14.4171L17.4537 15.1189L16.9685 14.3828L18.7095 13.127H19.3768V19.0503H18.4191V14.4171Z"
					fill="#1A73E8"
				/>
				<path
					d="M21.0943 25.6728L25.679 21.088L23.3866 20.0692L21.0943 21.088L20.0754 23.3804L21.0943 25.6728Z"
					fill="#EA4335"
				/>
				<path
					d="M9.88672 23.3805L10.9055 25.6729H21.094V21.0881H10.9055L9.88672 23.3805Z"
					fill="#34A853"
				/>
				<path
					d="M7.84902 6.31488C7.00472 6.31488 6.3208 6.9988 6.3208 7.8431V21.0881L8.61318 22.1069L10.9056 21.0881V10.8996H21.094L22.1128 8.60726L21.0941 6.31488H7.84902Z"
					fill="#4285F4"
				/>
				<path
					d="M6.3208 21.0881V24.1447C6.3208 24.9891 7.00472 25.6729 7.84902 25.6729H10.9056V21.0881H6.3208Z"
					fill="#188038"
				/>
				<path
					d="M21.0938 10.8997V21.0882H25.6785V10.8997L23.3861 9.88092L21.0938 10.8997Z"
					fill="#FBBC04"
				/>
				<path
					d="M25.6785 10.8996V7.84304C25.6785 6.99864 24.9946 6.31482 24.1503 6.31482H21.0938V10.8996H25.6785Z"
					fill="#1967D2"
				/>
			</g>
		</svg>
	);
};
